import React from 'react';

interface ErrorBoundaryState {
    hasError: boolean;
}

interface ErrorBoundaryProps {
    children: React.ReactNode;
}

class ErrorBoundary extends React.PureComponent<ErrorBoundaryProps, ErrorBoundaryState> {
    state: ErrorBoundaryState = {
        hasError: false,
    };

    static getDerivedStateFromError(): ErrorBoundaryState {
        return {
            hasError: true,
        };
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
        console.error(error, errorInfo);
    }

    render(): React.ReactNode {
        const {hasError} = this.state;
        const {children} = this.props;

        if (hasError) {
            return React.Children.map(children, (child) => 
                React.isValidElement(child) 
                    ? React.cloneElement(child, {hasError}) 
                    : child
            );
        }

        return children;
    }
}

export default ErrorBoundary; 